module.exports = __webpack_public_path__ + "img/nutrition_2.c86d4631.jpg";